import React from "react";
import { BarChart3, Database } from "lucide-react";
import ConditionalChart from "./DynamicChartRenderer/DyanamicChartRenderer";

const ChartContainer = ({ response, data, title, loading, theme = "light" }) => {
  const isDark = theme === "dark";
  if (loading) {
    return (
      <div className={`flex h-full items-center justify-center rounded-2xl border p-6 shadow-sm ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}>
        <img src="/chat/thinking.gif" alt="Loading" className="h-20 w-20" />
      </div>
    );
  }

  const rowsCount = data?.rows?.length || 0;
  const graphStatus = title?.graph_Status;

  if (!response) {
    return (
      <div className={`flex h-full flex-col items-center justify-center rounded-2xl border border-dashed p-6 text-center ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}>
        <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${isDark ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-500"}`}>
          <BarChart3 size={20} />
        </div>
        <div className={`mt-3 text-sm font-semibold ${isDark ? "text-slate-200" : "text-slate-700"}`}>Get Started Your Analysis !</div>
        <div className={`text-xs ${isDark ? "text-slate-500" : "text-slate-500"}`}>Ask a question to generate best visualizations report results.</div>
      </div>
    );
  }

  if (graphStatus === false || rowsCount <= 1) {
    return (
      <div className={`flex h-full flex-col items-center justify-center rounded-2xl border border-dashed p-6 text-center ${isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"}`}>
        <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${isDark ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-500"}`}>
          <BarChart3 size={20} />
        </div>
        <div className={`mt-3 text-sm font-semibold ${isDark ? "text-slate-200" : "text-slate-700"}`}>Visualization Not Applicable !</div>
        <div className={`text-xs ${isDark ? "text-slate-500" : "text-slate-500"}`}>This query doesn't have a suitable visualization.</div>
      </div>
    );
  }

  return <ConditionalChart data={data} title={title} theme={theme} height="100%" showLegend={true} />;
};

export default ChartContainer;
